import { combineReducers } from "redux";

import FormaPagamentoReducer from './api/formaPagamento';
import CondicaoPagamentoReducer from './api/condicaoPagamento';
import TagReducer from './api/tag';
import TipoEspacoReducer from './api/tipoEspaco';
import StatusReservaReducer from './api/statusReserva';

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    formasPagamento: FormaPagamentoReducer,
    tags: TagReducer,
    condicoesPagamento: CondicaoPagamentoReducer,
    tiposEspaco: TipoEspacoReducer,
    statusReserva: StatusReservaReducer,
});

export default rootReducer;